import { createFileRoute } from "@tanstack/react-router";

import SkillsAdmin from "@/components/SkillsAdmin";

export const Route = createFileRoute("/admin/skills")({
  component: SkillsAdmin,
});
